
























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ScheduleLogEntry } from "@/store/modules/types";
import { ScheduleLogType } from "@/store/modules/enums";
import { VueEditor } from "vue2-editor";
import ModalHeader from "../ModalHeader.vue";
import { getDate } from '@/services/timezone';

@Component({
  components: {
    ModalHeader,
    VueEditor,
  },
})
export default class Log extends Vue {
  @Prop() readonly appt: any;
  @Prop() readonly embedded?: boolean;
  @Prop() readonly showComment?: boolean;
  log: Array<any> = [];
  comment = "";
  getDate = getDate;
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ],
  };
  async getLog() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      this.log = await this.$store.dispatch("schedule/getLog", this.appt.id);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async saveComment(sendToPatient: boolean) {
    if (!this.comment) return;
    const entry: ScheduleLogEntry = {
      apptId: this.appt.id,
      typeId: sendToPatient
        ? ScheduleLogType.OFFICE_TO_PATIENT_COMMENT
        : ScheduleLogType.OFFICE_COMMENT,
      comment: this.comment,
    };
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/saveLog", entry);
      this.getLog();
      this.comment = "";
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async markRead(log) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/markLogRead", log.id);
      this.getLog();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  get unreadComments() {
    return this.log.filter((row) => {
      return (
        !row.isRead &&
        (row.typeId === ScheduleLogType.PATIENT_COMMENT ||
          row.typeId === ScheduleLogType.DRIVER_COMMENT)
      );
    });
  }

  formatText(text) {
    return text.replace(/(?:\*)(?:(?!\s))((?:(?!\*|\n).)+)(?:\*)/g, '<b>$1</b>')
      .replace(/(?:_)(?:(?!\s))((?:(?!\n|_).)+)(?:_)/g, '<i>$1</i>')
      .replace(/(?:~)(?:(?!\s))((?:(?!\n|~).)+)(?:~)/g, '<s>$1</s>')
      .replace(/(?:--)(?:(?!\s))((?:(?!\n|--).)+)(?:--)/g, '<u>$1</u>')
      .replace(/(?:```)(?:(?!\s))((?:(?!\n|```).)+)(?:```)/g, '<tt>$1</tt>')
      .replace(/\n|\r/g, "<br>");
  }

  formatTextBK(value) {
    var regex = /\*([a-zA-Z:\d\w\s]+)\*/gi;
    value = value.replace(regex, "<strong>$1</strong>")

    regex = /\n|\r/g;
    value = value.replace(regex, "<br>");
    return value;
  }
  mounted() {
    this.getLog();
  }
}
